(() => {
  if (!customElements.get('lc-concept-details')) {
    customElements.define('lc-concept-details', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const headings = [...this.querySelectorAll('h2,h3')];
        if (!headings.length) return;
        const introRange = document.createRange();
        introRange.setStart(this, 0);
        introRange.setEndBefore(headings[0]);
        const intro = document.createElement('div');
        intro.className = 'lc-details-intro';
        intro.append(introRange.cloneContents());
        // The first paragraph is already shown alongside the product photograph.
        intro.querySelector('p')?.remove();
        const grid = document.createElement('div');
        grid.className = 'lc-factory-coverage lc-details-grid';
        headings.forEach((heading, index) => {
          const article = document.createElement('div');
          const number = document.createElement('span');
          number.className = 'lc-detail-number';
          number.setAttribute('aria-hidden', 'true');
          number.textContent = String(index + 1).padStart(2, '0');
          const title = document.createElement('h3');
          title.textContent = heading.textContent;
          const body = document.createElement('div');
          body.className = 'lc-detail-body';
          const range = document.createRange();
          range.setStartAfter(heading);
          if (headings[index + 1]) range.setEndBefore(headings[index + 1]);
          else range.setEnd(this, this.childNodes.length);
          body.append(range.cloneContents());
          article.append(number, title, body);
          grid.append(article);
        });
        this.replaceChildren();
        if (intro.textContent.trim()) this.append(intro);
        this.append(grid);
        this.dataset.ready = 'true';
      }
    });
  }
  if (!customElements.get('lc-concept-fitment')) {
    customElements.define('lc-concept-fitment', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const catalog = JSON.parse(this.querySelector('[data-concept-models]').textContent);
        const model = this.querySelector('[data-concept-model]');
        const year = this.querySelector('[data-concept-year]');
        const placeholder = year.options[0].textContent;
        Object.keys(catalog.models).forEach(value => model.add(new Option(value, value)));
        model.addEventListener('change', () => {
          const previous = year.value;
          const years = catalog.models[model.value] || [];
          year.replaceChildren(new Option(placeholder, ''), ...years.map(value => new Option(value, value)));
          if (years.includes(previous)) year.value = previous;
        });
      }
    });
  }
  function initialize(scope = document) {
    scope.querySelectorAll('.lc-concept').forEach(product => {
      if (product.dataset.conceptReady) return;
      product.dataset.conceptReady = 'true';
      const summary = product.querySelector('[data-concept-summary] span');
      if (!summary) return;
      const update = () => {
        const fields = [...product.querySelectorAll('variant-selects .variations fieldset')];
        fields.sort((a, b) => Number(getComputedStyle(a).order) - Number(getComputedStyle(b).order));
        const values = fields.map(field => field.querySelector('select,input:checked')?.value).filter(Boolean);
        const model = product.querySelector('[data-concept-model]')?.value;
        const year = product.querySelector('[data-concept-year]')?.value;
        summary.textContent = [model, year, ...values].filter(Boolean).join(' · ');
      };
      product.addEventListener('change', update);
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
